import { guid } from '@/utils/helpers'

/**
 * This mixin is used to manage the state of lazy-hydrated components.
 * It stores state information (such as whether a component is mounted
 * and its current refresh key) for each component identified by a
 * unique identifier.
 *
 * This mixin is especially useful in scenarios where a content refresh
 * might cause DOM mismatches. In those cases, any lazy-hydrated
 * component that has not been mounted yet can be forced to re-render
 * by updating its refresh key. This avoids inconsistencies between the
 * server-rendered markup and the client-side state.
 */
export default {
  data() {
    return {
      lazyHydratedComponentState: {}
    }
  },
  methods: {
    $_lazyHydratedComponentState_getHydratedComponentRefreshKey(
      componentIdentifier
    ) {
      return this.lazyHydratedComponentState?.[componentIdentifier]?.refreshKey
    },
    $_lazyHydratedComponentState_onHydratedComponentMounted(
      componentIdentifier
    ) {
      const state = this.lazyHydratedComponentState[componentIdentifier]

      this.lazyHydratedComponentState[componentIdentifier] = state
        ? {
            ...state,
            isMounted: true
          }
        : {
            isMounted: true,
            refreshKey: undefined
          }
    },
    $_lazyHydratedComponentState_rerenderNonHydratedComponents(
      componentIdentifiers
    ) {
      componentIdentifiers.forEach(identifier => {
        if (this.lazyHydratedComponentState?.[identifier]?.isMounted) {
          return
        }

        const state = this.lazyHydratedComponentState[identifier]

        this.lazyHydratedComponentState[identifier] = state
          ? {
              ...state,
              refreshKey: guid()
            }
          : {
              isMounted: false,
              refreshKey: guid()
            }
      })
    }
  }
}
